export default "__VITE_ASSET__CZKj11Tl__"